export default __webpack_public_path__ + "static/media/chevron-down.f61011c8.svg";